// [#137] 그룹에 포함될 지식을 고르는 동안(기존 그룹에 추가 / 새 그룹 만들 때 모두) 후보 노드가
// 가려지지 않도록 엣지는 완전히 숨기고, 노드는 항상 완전히 불투명하게 강제한다.
// setFocus 등 기존 코드가 특정 엣지에 imperative하게 opacity를 지정해두는 경우가 있어
// 클래스 기반 스타일(.prepare)은 그 값에 덮어써질 수 있다. 반드시 imperative style()로
// 직접 지정해야 어떤 상태에서 진입하든 확실히 우선 적용된다.
export function applyGroupSelectionDimming(active) {
    const cy = window.cy;
    if (!cy) return;
    if (active) {
        cy.nodes().style('opacity', 1);
        cy.edges().style('opacity', 0);
    } else {
        cy.nodes().style('opacity', '');
        cy.edges().style('opacity', '');
    }
}
